"use client";

import React from "react";

interface SmokeDotProps {
  pathId: string;
  dur: string;
  begin: string;
}

const SmokeDot: React.FC<SmokeDotProps> = ({ pathId, dur, begin }) => (
  <circle r="3" fill="#9aa3b8">
    <animateMotion dur={dur} repeatCount="indefinite" begin={begin}>
      <mpath href={`#${pathId}`} />
    </animateMotion>
    <animate
      attributeName="opacity"
      values="0;1;0"
      dur={dur}
      repeatCount="indefinite"
      begin={begin}
    />
    <animate
      attributeName="r"
      values="3.2;2;0.8"
      dur={dur}
      repeatCount="indefinite"
      begin={begin}
    />
  </circle>
);

interface SmokeTrailProps {
  pathId: string;
  dur: number;  
  count?: number;
}

const SmokeTrail: React.FC<SmokeTrailProps> = ({ pathId, dur, count = 10 }) => {
  const dots = Array.from({ length: count }, (_, i) => ({
    begin: i === 0 ? "0s" : `-${((i * dur) / count).toFixed(2)}s`,
    dur: `${dur}s`,
  }));

  return (
    <>
      {dots.map((dot, i) => (
        <SmokeDot key={i} pathId={pathId} dur={dot.dur} begin={dot.begin} />
      ))}
    </>
  );
};

export default function Loader() {
  return (
    <div className="flex flex-col items-center justify-center">
      <svg
        className="h-24 w-auto sm:h-28"
        viewBox="0 0 160 320"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="status"
      >
        <path
          id="sl"
          d="M52 175 Q30 145 42 110 Q54 75 34 45 Q18 18 30 -10"
          stroke="none"
          fill="none"
        />
        <path
          id="sc"
          d="M80 170 Q96 138 78 105 Q60 72 76 40 Q88 12 74 -16"
          stroke="none"
          fill="none"
        />
        <path
          id="sr"
          d="M108 175 Q132 143 118 108 Q104 73 124 42 Q140 16 126 -12"
          stroke="none"
          fill="none"
        />

        <line x1="80" y1="272" x2="52"  y2="178" stroke="#4a5568" strokeWidth="3.5" strokeLinecap="round" />
        <line x1="80" y1="272" x2="80"  y2="173" stroke="#4a5568" strokeWidth="3.5" strokeLinecap="round" />
        <line x1="80" y1="272" x2="108" y2="178" stroke="#4a5568" strokeWidth="3.5" strokeLinecap="round" />

        <polygon points="80,258 60,282 100,282" fill="#4a5568" />

        <SmokeTrail pathId="sl" dur={3.0} count={10} />
        <SmokeTrail pathId="sc" dur={2.6} count={10} />
        <SmokeTrail pathId="sr" dur={3.2} count={10} />
      </svg>
    </div>
  );
}